import { authFetch } from "@/lib/api-client";
import type { CreateCreativeFlagRequest, CreativeFlagDto } from "@nexus/contracts";

export async function createCreativeFlag(payload: CreateCreativeFlagRequest): Promise<CreativeFlagDto> {
  const { data } = await authFetch<CreativeFlagDto>("/creative-flags", {
    method: "POST",
    body: JSON.stringify(payload),
  });
  return data;
}

export async function fetchCreativeFlags(creativeHash: string): Promise<CreativeFlagDto[]> {
  const { data } = await authFetch<CreativeFlagDto[]>(
    `/creative-flags?creativeHash=${encodeURIComponent(creativeHash)}`,
  );
  return data;
}

export async function deleteCreativeFlag(id: string): Promise<void> {
  await authFetch(`/creative-flags/${encodeURIComponent(id)}`, { method: "DELETE" });
}
